<template>
  <div>
    <div id="show-location" style="height: 200px;margin-right:5px"></div>
  </div>

</template>

<script>
  import {map, tileLayer} from 'leaflet';
  import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
  import 'leaflet-fullscreen/dist/Leaflet.fullscreen';
  import {GeoSearchControl, OpenStreetMapProvider} from 'leaflet-geosearch';

  export default {
    name: "ShowLocation",
    mounted() {

      try {
        var map = L.map('show-location', {fullscreenControl: true});
        L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png')
          .addTo(map);

        if (this.default) {
          this.student = Object.assign({}, this.data)
          let latlng = new L.latLng(this.default.latitude, this.default.longitude);
          this.marker = L.marker(latlng)
          this.marker.addTo(map)
          this.markerLatLng = {
            latitude: latlng.lat,
            longitude: latlng.lng,
          }
          map.setView([latlng.lat, latlng.lng], 14);
        } else {
          map.setView([35.715298, 51.404343], 12); //tehran location
        }

        this.map = map
      }catch (e) {
        map.invalidateSize();
      }

    },
    data() {
      return {
        map: null,
        mapIsLock: this.editLock,
        marker: '',
        markerLatLng: {
          latitude: '',
          longitude: ''
        },
      }
    },

    props: {
      default: {
        type: [Object, String],
      },
    }
  }
</script>

<style scoped>

</style>
